// 公共页头
<template>
  <div class="header">
    <div class="hcenter">
      <div class="top">
        <div class="name"></div>
        <div class="phone">咨询电话：0371-65353150</div>
      </div>
    </div>
    <div class="nav">
      <div class="navCenter">
        <div class="navLeft">
          <ul class="navlist">
            <li
              class="navList"
              v-for="(item, index) in nav"
              @click="dianji(index)"
              @mouseenter="isShow(index)"
              :key="index"
            >
              <img :src="item.urll" alt="icon" class="iconImg" />
              <p class="iconName">{{ item.name }}</p>
            </li>
          <ul class="messageList" v-show="showmsg" @mouseleave="hide">
            <li class="message">
              <a href="javascript:;" @click="project">工程项目质量全面提升过程咨询</a>
            </li>
            <li class="message">
              <a href="javascript:;" @click="train">专项培训</a>
            </li>
            <li class="message">
              <a href="javascript:;" @click="information">项目信息化建设</a>
            </li>
            <li class="message">
              <a href="javascript:;" @click="law">法律服务咨询</a>
            </li>
            <li class="message">
              <a href="javascript:;" @click="double">双重预防体系咨询服务</a>
            </li>
            <li class="message">
              <a href="javascript:;" @click="items">项目汇报视频PPT材料服务</a>
            </li>
          </ul>
          </ul>
        </div>
        <div class="navRight">
          <div class="topInpt">
            <input type="text" class="topInput" placeholder="全站搜索" v-model="searchVal" />
            <img
              src="../assets/img/icon/navIcon/search.svg"
              alt="search"
              class="inputSearch"
              @click="search"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      searchVal: "",
      nav: [
        {
          name: "首页",
          urll: require("../assets/img/icon/navIcon/首 页.svg"),
        },
        {
          name: "业务介绍",
          urll: require("../assets/img/icon/navIcon/业务.svg"),
        },
        {
          name: "服务清单",
          urll: require("../assets/img/icon/navIcon/服务.svg"),
        },
        {
          name: "新闻中心",
          urll: require("../assets/img/icon/navIcon/新闻.svg"),
        },
        {
          name: "关于我们",
          urll: require("../assets/img/icon/navIcon/关于我们.svg"),
        },
        {
          name: "联系我们",
          urll: require("../assets/img/icon/navIcon/联系.svg"),
        },
      ],
      showmsg: false,
    };
  },
  created() {
    var query = this.$route.query;
    let lat = query.lat;
    console.log(lat);
  },
  methods: {
    dianji(index) {
      if (index == 2) {
        this.$router.replace("/serveMsg");
      } else if (index == 3) {
        this.$router.replace("/news");
      } else if (index == 4) {
        this.$router.replace("/aboutour");
      } else if (index == 5) {
        this.$router.replace("/serve");
      } else if (index == 0) {
        this.$router.replace("/");
      }
    },
    isShow(index) {
      if (index == 1) {
        this.showmsg = true;
      } else if (index == 2) {
        this.showmsg = false;
      } else if (index == 3) {
        this.showmsg = false;
      } else if (index == 4) {
        this.showmsg = false;
      } else if (index == 5) {
        this.showmsg = false;
      } else if (index == 0) {
        this.showmsg = false;
      }
    },
    hide() {
      this.showmsg = false;
    },
    project() {
      this.$router.replace("/project");
    },
    items() {
      this.$router.replace("/items");
    },
    law() {
      this.$router.replace("/law");
    },
    information() {
      this.$router.replace("/information");
    },
    train() {
      this.$router.replace("/train");
    },
    double() {
      this.$router.replace("/double");
    },
    aboutour() {
      this.$router.replace("/aboutour");
    },
    search() {
      if (this.searchVal == "") {
        return;
      } else {
        this.$emit("cSearchVal", this.searchVal);
        this.$router.replace("/news");
      }
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 135px;
  font-size: 12px;
  position: fixed;
  top: 0;
  z-index: 1000;
  background-color: #fff;
  .hcenter {
    width: 1160px;
    height: 76px;
    margin: 0 auto;
  }
  .top {
    width: 100%;
    height: 76px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      width: 430px;
      height: 56px;
      background: url("../assets/img/icon/headernn.png") center no-repeat;
      background-size: cover;
      // position: absolute;
      // top: 14px;
      // left: 361px;
    }
    .phone {
      width: 400px;
      height: 25px;
      opacity: 1;
      font-size: 24px;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      color: #4279db;
      // position: absolute;
      // top: 37px;
      // left: 1273px;
    }
  }
  .nav {
    width: 100%;
    height: 60px;
    background: #4279db;
    // position: relative;
    box-sizing: border-box;
    .navLeft {
      width: 720px;
      height: 60px;
      display: flex;
    }
    .navRight{
      width: 245px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .navlist {
      width: 100%;
      height: 60px;
      display: flex;
      box-sizing: border-box;
      position: relative;
      margin: 0;
      padding: 0px;
      .navList {
        width: 120px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: white;

        .iconImg {
          width: 18px;
          height: 17px;
          display: inline-block;
          float: left;
          margin-right: 8px;
          box-sizing: border-box;
        }
      }
    }
    .messageList {
      padding-left: 10px;
      padding: 0;
      margin: 0;
      position: absolute;
      top: 60px;
      left: 119px;
      width: 230px;
      height: 168px;
      background: #4279db;
      .message {
        padding-left: 20px;
        width: 210px;
        height: 28px;
        opacity: 1;
        a {
          display: block;
          font-size: 14px;
          color: #ffffff;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          line-height: 25px;
        }
      }
    }
    .topInpt {
      position: relative;
      .topInput {
        width: 245px;
        height: 32px;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #666666;
        border-radius: 16px;
        padding: 0px 50px 0px 23px;
        outline: none;
        border: none;
        box-sizing: border-box;
      }
      .inputSearch {
        width: 15px;
        height: 15px;
        opacity: 1;
        position: absolute;
        top: 9px;
        right: 26px;
      }
    }
  }
}
.navList:hover {
  cursor: pointer;
  background-color: #003489;
}
.inputSearch:hover {
  cursor: pointer;
}
.message:hover {
  background-color: #003489;
}
.navCenter {
  width: 1160px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
